import Cookies from "js-cookie";

export class TokenStore {
  private static readonly ACCESS_KEY = "userToken";
  private static readonly REFRESH_KEY = "refreshToken";

  static getAccessToken(): string | null {
    return Cookies.get(this.ACCESS_KEY) ?? localStorage.getItem(this.ACCESS_KEY) ?? null;
  }

  static setAccessToken(token: string): void {
    localStorage.setItem(this.ACCESS_KEY, token);
  }

  static clearAccessToken(): void {
    localStorage.removeItem(this.ACCESS_KEY);
    Cookies.remove(this.ACCESS_KEY);
  }

  static getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_KEY) ?? null;
  }

  static setRefreshToken(token: string): void {
    localStorage.setItem(this.REFRESH_KEY, token);
  }

  static clearRefreshToken(): void {
    localStorage.removeItem(this.REFRESH_KEY);
  }

  static clear(): void {
    this.clearAccessToken();
    this.clearRefreshToken();
  }
}

// Backwards-compatible alias — existing callers keep working.
export function getAuthToken(): string | null {
  return TokenStore.getAccessToken();
}
